import {
  EsignFieldKind,
  type PublicSignerSessionResponse,
  type PublicSignerSubmitRequest
} from '../publicSignerTypes';

import {
  getCheckboxFieldValue,
  getSignatureFieldValue,
  getTextFieldValue,
  isFieldEditable
} from './fieldValue';
import type { PublicSignerFieldDraftValues } from './types';

export function buildPublicSignerSubmitRequest(
  session: PublicSignerSessionResponse,
  fieldDraftValues: PublicSignerFieldDraftValues,
  isDisclosureAccepted: boolean
): PublicSignerSubmitRequest {
  const hasSignatureValues = session.fields.some(
    (field) =>
      isFieldEditable(field) &&
      field.field_kind === EsignFieldKind.Signature &&
      Boolean(getSignatureFieldValue(fieldDraftValues[field.id]))
  );

  return {
    ...(hasSignatureValues && isDisclosureAccepted
      ? { disclosure_accepted: true }
      : {}),
    fields: session.fields.filter(isFieldEditable).map((field) => {
      const draftValue = fieldDraftValues[field.id];

      if (field.field_kind === EsignFieldKind.Checkbox) {
        return {
          field_id: field.id,
          field_kind: EsignFieldKind.Checkbox,
          value: getCheckboxFieldValue(draftValue)
        };
      }

      if (field.field_kind === EsignFieldKind.Signature) {
        return {
          field_id: field.id,
          field_kind: EsignFieldKind.Signature,
          value: getSignatureFieldValue(draftValue)
        };
      }

      const nextValue = getTextFieldValue(draftValue);

      return {
        field_id: field.id,
        field_kind: EsignFieldKind.Text,
        value: nextValue.trim() ? nextValue : null
      };
    })
  };
}
